import React, { useState, useEffect } from "react";
import { createGroup, updateGroup } from "./adminSimilarWordsService";
import "../../styles/content.css";

const WordGroupForm = ({ group, onSaved, onCancel }) => {
  const isEdit = !!group;
  const [form, setForm] = useState({ title: "", youtubeVideoLink: "", isActive: true, displayOrder: 1 });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (group) {
      console.log("[WordGroupForm] Populating for edit, id:", group.id);
      setForm({
        title: group.title || "", youtubeVideoLink: group.youtubeVideoLink || "",
        isActive: group.isActive !== false, displayOrder: group.displayOrder || 1,
      });
    }
  }, [group]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async () => {
    if (!form.title) { alert("Title is required"); return; }
    const payload = { ...form, displayOrder: Number(form.displayOrder) || 1 };
    console.log("[WordGroupForm] Submitting", isEdit ? "update" : "create", "payload:", payload);
    setLoading(true);
    const res = isEdit ? await updateGroup(group.id, payload) : await createGroup(payload);
    if (res.status === 200 || res.status === 201) { console.log("[WordGroupForm] Success:", res.status); onSaved(); }
    else { console.error("[WordGroupForm] Failed:", res.status, res.message); alert(res.message || "Operation failed"); }
    setLoading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: 500, maxHeight: "90vh", overflowY: "auto" }}>
        <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
          <h2>{isEdit ? "Edit" : "Create"} Word Group</h2>
          <div className="form-group"><label>Title *</label><input name="title" placeholder="e.g. Break, Brake" value={form.title} onChange={handleChange} /></div>
          <div className="form-group"><label>YouTube Video Link</label><input name="youtubeVideoLink" placeholder="https://youtube.com/watch?v=..." value={form.youtubeVideoLink} onChange={handleChange} /></div>
          <div className="form-group"><label>Display Order</label><input name="displayOrder" type="number" min="1" value={form.displayOrder} onChange={handleChange} /></div>
          <div className="form-group"><label style={{ display: "flex", alignItems: "center", gap: 8 }}><input name="isActive" type="checkbox" checked={form.isActive} onChange={handleChange} /> Active</label></div>
          <div className="form-actions"><button onClick={handleSubmit} disabled={loading}>{loading ? "Saving..." : isEdit ? "Update" : "Create"}</button><button onClick={onCancel} disabled={loading}>Cancel</button></div>
        </div>
      </div>
    </div>
  );
};

export default WordGroupForm;
